import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import { warmUpServer } from './services/api';
import './styles/index.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root missing');

warmUpServer();

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
